import Fab from 'components/Fab'

import styled from 'styled-components'

export const FabStyled = styled(Fab)`
  svg {
    margin-right: 8px;
  }
`
